import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { RolesEnum } from './roles';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.authService.user;

        if (!user || !this.authService.token) {
            this.authService.signOut();
            this.router.navigate(['/sign-in'], { queryParams: { returnUrl: state.url }});
            return false;
        }

        // Verifica se o usuário tem o perfil de administrador
        const roles = (user as any)?.realm_access?.roles || (user as any)?.roles || [];
        const isAdmin = Array.isArray(roles) && roles.includes(RolesEnum.GESTAO_ADMIN);

        if (!isAdmin) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
